export function formatFeeHistory(feeHistory) {
  var _feeHistory$reward;
  return {
    baseFeePerGas: feeHistory.baseFeePerGas.map(value => BigInt(value)),
    gasUsedRatio: feeHistory.gasUsedRatio,
    oldestBlock: BigInt(feeHistory.oldestBlock),
    reward: (_feeHistory$reward = feeHistory.reward) === null || _feeHistory$reward === void 0 ? void 0 : _feeHistory$reward.map(reward => reward.map(value => BigInt(value)))
  };
}
//# sourceMappingURL=feeHistory.js.map